import { partial } from 'lodash/fp';
import { type } from '@mews/framework';
import ApiComponent from '../apiComponent';
import createRequest from './misc/createRequest';
import searchable from './traits/searchable';

const BASE_URL = '/reservationGroups';

export default function ReservationGroupComponent(apiComponent: $TSFixMe) {
    type.check(apiComponent, ApiComponent);
    const request = createRequest(apiComponent.request, BASE_URL);

    return type.create(ReservationGroupComponent, searchable(partial(request, ['/search'])), {
        create({
            profileId,
            groupId,
            enterpriseId,
            serviceId,
            customerId,
            bookerId,
            sendEmail,
            mailReceivers,
            customLanguageCode,
            reservations,
        }: $TSFixMe) {
            return request('/create', {
                profileId,
                groupId,
                enterpriseId,
                serviceId,
                customerId,
                bookerId,
                sendEmail,
                mailReceivers,
                customLanguageCode,
                reservations,
            });
        },

        get({ groupId, serviceId }: $TSFixMe) {
            return request('/get', { groupId, serviceId });
        },

        price({ profileId, enterpriseId, serviceId, reservations }: $TSFixMe) {
            return request('/price', { profileId, reservations, enterpriseId, serviceId });
        },
    });
}
